import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import Translate from 'components/Translate';
import WarningIcon from '../assets/WarningIcon';

import {
  proceedAction as proceedActionRedux,
  cancelAction as cancelActionRedux,
} from '../services/confirmAction/action';
import BlueButton from "../components-new/buttons/BlueButton";
import SilverButton from "../components-new/buttons/SilverButton";
import config from "../config";

const baseStyle = {
  overlay: {
    backgroundColor: config.modalBackgroundColor,
    zIndex: '2000',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '20px',
    transform: 'translate(-50%, -50%)',
    padding: '40px',
    border: 'none',
  },
  circleWrapper: {
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'center',
  },
  circle: {
    backgroundColor: '#E14E52',
    borderRadius: '50%',
    height: '90px',
    width: '90px',
    display: 'flex',
    alignContent: 'center',
    padding: '24px 24px',
  },
  title: {
    color: '#09183A',
    fontSize: '18px',
    marginBottom: '30px',
  },
  buttonsWrapper: {
    textAlign: 'center',
    display: 'flex'
  },
  confirmButton: {
    cursor: 'pointer',
    width: '140px',
    border: 'none',
    borderRadius: '20px',
    padding: '15px 45px',
    backgroundColor: '#E14E52',
    color: '#FFFFFF',
    fontSize: '16px',
    WebkitBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
    MozBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
    boxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
  },
  refuseButton: {
    cursor: 'pointer',
    width: '140px',
    marginRight: '10px',
    border: 'none',
    borderRadius: '20px',
    backgroundColor: '#e5e5e559',
    color: '#09183A',
    padding: '15px 45px',
    fontSize: '16px',
    WebkitBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
    MozBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
    boxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
  },
};

Modal.setAppElement('#root');

class ConfirmModal extends Component {
  closeModal = () => {
    const { cancelAction } = this.props;
    cancelAction();
  };

  render() {
    const { proceedAction, cancelAction, isOpen, content } = this.props;

    const dynamicStyle = {
      ...baseStyle,
      overlay: content ? { backgroundColor: 'none' } : baseStyle.overlay,
    };

    return (
      <Modal closeTimeoutMS={config.closeTimeoutMS} isOpen={isOpen} style={dynamicStyle} onRequestClose={this.closeModal}>
        <div className="wrapper" style={baseStyle.wrapper}>
          {content ? content : (
            <React.Fragment>
              <div style={baseStyle.circleWrapper}>
                <div style={baseStyle.circle}>
                  <div>
                    <WarningIcon width="40px" height="40px" />
                  </div>
                </div>
              </div>
              <p style={baseStyle.title}>
                <Translate text="areYouSureYouWantToProceed" />
              </p>
              <div className="buttons" style={baseStyle.buttonsWrapper}>
                <SilverButton styles={{marginRight:'20px'}} type={'submit'} onClick={cancelAction} children={<Translate text="no" />}/>
                <BlueButton type={'submit'} onClick={proceedAction} children={<Translate text="yes" />}/>
              </div>
            </React.Fragment>
          )}
        </div>
      </Modal>
    );
  }
}

ConfirmModal.propTypes = {
  proceedAction: PropTypes.func.isRequired,
  cancelAction: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isOpen: state.confirmAction.isModalOpen,
  content: state.confirmAction.content,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  proceedAction: () => {
    dispatch(proceedActionRedux());
  },
  cancelAction: () => {
    dispatch(cancelActionRedux());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModal);



// WEBPACK FOOTER //
// ./src/components/ConfirmModal.jsx